module.exports = __webpack_public_path__ + "media/images/official/guide_image3-c2aacc79f1ee6d19c883e5e6b9e8b710.svg";